// Header.js - Add navigation links
import { Link, useNavigate} from 'react-router-dom';
import styles from './Header.module.css';
import { useState } from 'react';

function Header({ onLogout, isLoggedIn, userData }) {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  }

  // Main nav items (keep it minimal)
  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/calendar', label: 'Calendar', icon: '📅' },
    { path: '/goals', label: 'Goals', icon: '🎯' },
    { path: '/blog', label: 'Blog', icon: '📝' },
    { path: '/leaderboard', label: 'Leaderboard', icon: '🏆' },
  ];

  // Dropdown menu items (profile, social)
  const dropdownItems = [
    { path: '/profile', label: 'My Profile', icon: '👤' },
    { path: '/insights', label: 'Insights', icon: '📈' },
    { path: '/friends', label: 'Friends', icon: '👥' },
    { path: '/badges', label: 'Badges', icon: '🏅' },
  ];

  return (
    <header className={styles.header}>
       {/* Logo Section */}
      <div className={styles.logoSection}>
        <Link to="/" className={styles.logoLink}>
          <img src="/logo192.png" alt="TrackMyFap" className={styles.logoImg} />
          <h1 className={styles.logoText}>TrackMyfap</h1>
        </Link>
      </div>

      {/* Desktop Navigation */}
      <nav className={styles.desktopNav}>
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={styles.navLink}
            activeclassname={styles.active}
          >
            <span className={styles.navIcon}>{item.icon}</span>
            {item.label}
          </Link>
        ))}
      </nav>

       {/* User Section */}
      <div className={styles.userSection}>
        {isLoggedIn ? (
          <>
            <div className={styles.userInfo}>
              <span className={styles.welcome}>Welcome, </span>
              <span className={styles.username}>{userData?.username || 'User'}</span>
            </div>
            <div className={styles.userDropdown}>
              <button className={styles.userAvatar}>
                {userData?.username?.charAt(0).toUpperCase() || 'U'}
              </button>
              <div className={styles.dropdownMenu}>
                {dropdownItems.map((item) => (
                  <Link key={item.path} to={item.path} className={styles.dropdownItem}>
                    {item.icon} {item.label}
                  </Link>
                ))}
                <div className={styles.dropdownDivider}></div>
                <button onClick={handleLogout} className={styles.dropdownItem}>
                  🚪 Logout
                </button>
              </div>
            </div>
          </>
        ) : (
          <Link to="/login" className={styles.loginButton}>
            Sign In
          </Link>
        )}
       {/* Mobile Menu Toggle */}
        <button
          className={styles.mobileMenuToggle}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile Navigation (Hidden by default) */}
      {isMobileMenuOpen && (
        <nav className={styles.mobileNav}>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={styles.mobileNavLink}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <span className={styles.mobileNavIcon}>{item.icon}</span>
              {item.label}
            </Link>
          ))}
          {isLoggedIn && (
            <button onClick={handleLogout} className={styles.mobileLogout}>
              🚪 Logout
            </button>
          )}
        </nav>
      )}

    </header>
  );
}

export default Header;